module.exports = __webpack_public_path__ + "static/5-9a3392b0a4b4fe7eca3daf736c81a255.jpeg";